import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';
class TNPSCCourse extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p>TNPSC stands for “Tamil Nadu Public Service Commission”. The Commission hires people in separate departments such as Group 1,2,3,4 services for the State Government Public Service.
                    </p><br/>
                    <p>The Public Service Commission is responsible for setting the TNPSC exams with the eligibility criteria for every individual aspiring to get into Government staff.</p>
                    </ScrollAnimation>	

                    <ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">The TNPSC Exam Range is as follows:</h5>
						
						<ul>
                            <li>Combined Civil Services Examination – I (Group 1 Services)</li>
                            <li>Combined Civil Services Examination – II (Group-II And Group-II A Services)</li>
                            <li>Combined Civil Services Examination-III (Group-III Services)</li>
                            <li>Combined Civil Services Examination-IV (Group-IV Services & VAO)</li>
                        </ul>
                    </ScrollAnimation>
               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
						{/* <h5 className="mb-0 mt-2"></h5><br/> */}
                        
                        <table>
							<tr>
								<th colspan="2">TNPSC Eligibility</th>
							</tr>
							<tr>
								<td>TNPSC Group 1 Exam Eligibility</td>
								<td>
                                    <ul>
                                        <li>Age Limit – General category 32 years, age relaxation of 5 years to SC, ST, OBC category</li>
                                        <li>Qualification – Graduation from a Government recognised university</li>
                                        <li>Special physical qualifications are needed for the posts of Deputy Superintendent of Police and the District Officer (Fire and Rescue Operations).</li>
                                    </ul>
                                </td>
							</tr>
							<tr>
								<td>TNPSC Group 2 Eligibility</td>
								<td>
                                    <ul>
                                        <li>Age Limit – 
                                            <ul>
                                                <li>Minimum – 18 years (20, 22, and 26 years respectively for the Sub-registrar Grade-II, the Probation officer in the Prison Department, and Probation Officer in the Social Defense department)</li>
                                                <li>Maximum – 30 years for general category while no age limit for Reserved Candidates.</li>
                                            </ul>
                                        </li>
                                        <li>Educational Qualification – varies according to the post specialization but minimum qualification is Graduation</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
								<td>TNPSC Group 3 Eligibility</td>
								<td>
                                    <ul>
                                        <li>Age Limit – 
                                            <ul>
                                                <li>Minimum – 18 years </li>
                                                <li>Maximum – 42 years</li>
                                            </ul>
                                        </li>
                                        <li>Minimum Education Qualification – Graduate </li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
								<td>TNPSC Group 4 Eligibility</td>
								<td>
                                    <ul>
                                        <li>Age Limit – 
                                            <ul>
                                                <li>Minimum – 18 years for general candidates</li>
                                                <li>Maximum – 30 years General candidates, 32 Years for MBC / Denotified Communities / BC and 35 years for SC / ST / Destitute Widows</li>
                                            </ul>
                                        </li>
                                        <li>Minimum Education Qualification – must have passed the S.S.L.C. Public examinations</li>
                                    </ul>
                                </td>
							</tr>
						</table><br/>
						</blockquote>
					</div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
						{/* <h5 className="mb-0 mt-2"></h5><br/> */}
                        
                        <table>
							<tr>
								<th colspan="2">TNPSC Exam Pattern </th>
							</tr>
							<tr>
								<td>TNPSC Group 1 Exam Pattern</td>
								<td>
                                    <ul>
                                        <li>Prelims – one objective paper – 300 marks – 3 hours</li>
                                        <li>Mains – three descriptive papers – 750 marks total – 9 hours total</li>
                                        <li>Interview – 100 marks</li>
                                    </ul>
                                </td>
							</tr>
							<tr>
								<td>TNPSC Group 2</td>
								<td>
                                    <ul>
                                        <li>Prelims – one objective paper – 300 marks – 3 hours
                                        </li>
                                        <li>Mains – two descriptive papers – 400 marks total</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
								<td>TNPSC Group 3</td>
								<td>
                                    <ul>
                                        <li>One Objective Paper – 300 Marks Total – 3 hours</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
								<td>TNPSC Group 4</td>
								<td>
                                    <ul>
                                        <li>One Objective Paper – 300 Marks Total – 3 hours</li>
                                    </ul>
                                </td>
							</tr>
						</table><br/>
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
                    <h5 className="mb-0 mt-2">HOW MIET HELPS YOU ACHIEVE YOUR DREAM CAREER:</h5>
                    <p>1. With its Experienced group of Teachers, MIET helps you stay focused by dedicated coaching and mentorship.</p>
                    <p>2.  We believe that every student has the potential to crack any exam with the proper guidance. MIET stands with you to help you achieve that.</p>
                    <p>3.  MIET helps you approach your exams with good clarity and readily equipped.</p>
                    <p>4.  All complicated concepts are simplified to make you understand better.</p>
                    <p>5.  MIET provides certain tips & tricks to crack your exam on time with no pressure.</p><br/>
                    <p><b>Mode of Coaching: Online & Offline</b></p>
                    <p><b>Batches: Regular, Evening & Weekend</b></p><br/>
                    </ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
                    <h5 className="mb-0 mt-2">MIET also provides coaching for other courses, such as:</h5><br/>
                    <h5 className="mb-0 mt-2">VAO:</h5>
                    <p>The full form of <b>TNPSC VAO </b>refers to the Tamil Nadu Public Service Commission Village Administrative Officer. The candidates who are studying for this prestigious state-level exam get recruited for the post of Village Administrative Officer (VAO). VAO comes under TNPSC Group 4 exams.</p><br/>
                   
                    <h5 className="mb-0 mt-2">TRB: </h5>
                    <p>The Teachers Recruitment Board (TRB) is an autonomous body established under the Ministry of Human Resource Development to recruit and appoint teachers to schools and other educational institutions. The Teachers Recruitment Board, otherwise known as the TRB, was established in 1987 solely to recruit teachers for government schools and colleges.</p><br/>
                    <p>It has its headquarters in New Delhi and four regional offices in Kolkata, Guwahati, Chennai, and Hyderabad.</p>
                    <p>The <b>Teachers Recruitment Board (TRB)</b> conducts the Tamil Nadu <b>Teachers Eligibility Test (TNTET)</b> exam.</p>
                    <br/>
                    <h5 className="mb-0 mt-2">TET: </h5>
                    <p>The TET stands for Teacher Eligibility Test which is conducted at the national as well as state level to shortlist candidates for appointment as teachers in schools.</p><br/>
                    <p>The basic eligibility criteria for TET exams are: Class 12 passed or a graduate with a minimum of 45 per cent marks Diploma in Education or Bachelor of Education (B.Ed) or completed teacher training programme/course.</p>
                    
                    </ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
                    <br/>
                    <h5 className="mb-0 mt-2">Police Officer Exams:</h5>
                    <p>A career as a Police Officer is valued as a prestigious position in society. If you want to serve the society, then becoming a Police officer is the right choice. </p><br/>
                    <p>The Police Department Exams with eligibility are as follows:</p><br/>
                    <table>
							<tr>
								<th>Name of the Post</th>
								<th>Eligibility</th>
								<th>Recruitment Exams</th>
							</tr>
							<tr>
								<td>Police Head Constable</td>
								<td>Class 12</td>
								<td>State-Level Recruitment Exam</td>
							</tr>
							<tr>
								<td>Constable</td>
								<td>Class 12 (Lower age limit is 18, and maximum age is 25)</td>
								<td>State-Level Recruitment Exam</td>
							</tr>
							<tr>
								<td>SP/ASP</td>
								<td>Bachelor’s Degree with Lower Age Limit of 21 years.</td>
								<td>IPS</td>
							</tr>
                            <tr>
                                <td>Assistant Commissioner/DSP</td>
								<td>Bachelor’s Degree with Lower Age Limit of 21 years.</td>
								<td>IPS</td>
							</tr>
                            <tr>
								<td>Circle Inspector & Sub-Inspector</td>
								<td>Bachelor’s Degree</td>
								<td>Staff Selection Commission (SSC)</td>
							</tr>
                            <tr>
								<td>Assistant Sub Inspector</td>
								<td>Head Constable of at least 5-7 years of experience</td>
								<td>State-Level Recruitment Exam or SSC</td>
							</tr>
						</table><br/>
					
                    </ScrollAnimation>	

                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <h5 className="mb-0 mt-2">SSC:</h5>
                    <p>SSC exam stands for Staff Selection Commission. An Indian organisation that recruits staff for various posts in the various Ministries and Departments of the Government of India. It is headquartered at New Delhi, India. </p>
                    <p>The Staff Service Commission conducts competitive examinations to recruit various services and posts. There are more than 20 types of jobs ranging from group B to group C. Eligibility criteria is graduation in any stream from a recognized university to apply for an SSC examination. Physical fitness and measurement are also required for some posts like the Sub-Inspector and Narcotics department.</p><br/>
                    
                    </ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <h5 className="mb-0 mt-2">RRB:</h5>
                    <p>RRB stands for Railway Recruitment Board and is managed by the Ministry of Railways under Railway Recruitment Control Board. The Railway Recruitment Board conducts various recruitment examinations for Assistant Loco Pilot, Non-technical and popular category, Group C/Group D and other posts in departments and offices of Indian railways. </p><br/>
                    <p>The examinations conducted under Railway Recruitment Board are:</p>
                    <ul>
                        <li>RRB NTPC</li>
                        <li>RRB ALP</li>
                        <li>RRB JE</li>
                        <li>RRB Group D</li>
                    </ul>

                    <h5 className="mb-0 mt-2">Mode of Coaching: Online & Offline</h5>
                    <h5 className="mb-0 mt-2">Batches: Regular, Evening & Weekend</h5>
                    </ScrollAnimation>
					

                  </div>
		      </div>
			  <Sidebar courseRestriction="TNPSC, TRB, Police Exams & RRB"/>
		    </div>
		  </div>
		</div>

        }
}

export default TNPSCCourse